import { Box, BoxProps, styled } from "@mui/material";
import { rem } from "polished";
import React from "react";

import { AmountFragment } from "src/graphql/generated/types";
import { formatAmount } from "src/utils";

import { amountCellWidth, focusOutline } from "../../../constants";
import { AmountLabel } from "../AmountLabel";

export const FirstLevelRowStyled = styled(Box)`
  cursor: pointer;
  background: ${(props) => props.theme.palette.primary.main};
  color: ${(props) => props.theme.palette.primary.contrastText};
  display: flex;
  &:focus-visible : ${focusOutline};       
  
  margin: 0 4px;

  > p {
    width: ${rem(amountCellWidth)};
    padding: ${(props) => props.theme.spacing(1.5)};
    border-left: 1px solid ${(props) => props.theme.palette.primary.contrastText};
    text-align: center;
    font-weight: 500;

    &:nth-of-type(1) {
      flex: 1;
      width: auto;
      display: flex;
      align-items: center;
      border-left: 0;
      text-align: left;
    }
  }
`;

export const StyledCell = styled("p")`
  margin: 0;
`;

export const StyledFlexCell = styled(StyledCell)`
  display: flex;
  flex-direction: column;
`;

type Props = {
  toAllocate: AmountFragment;
  vat: AmountFragment;
  recoverable: AmountFragment;
  ariaLabel?: string;
} & BoxProps;

export const FirstLevelRow = ({
  children,
  toAllocate,
  vat,
  recoverable,
  ariaLabel,
  ...boxProps
}: Props) => {
  return (
    <FirstLevelRowStyled {...boxProps} aria-label={ariaLabel} role="group">
      <StyledCell>{children}</StyledCell>
      <StyledFlexCell>
        <AmountLabel>A répartir</AmountLabel>
        {formatAmount(toAllocate)}
      </StyledFlexCell>
      <StyledFlexCell>
        <AmountLabel>TVA</AmountLabel>
        {formatAmount(vat)}
      </StyledFlexCell>
      <StyledFlexCell>
        <AmountLabel>Récupérable</AmountLabel>
        {formatAmount(recoverable)}
      </StyledFlexCell>
    </FirstLevelRowStyled>
  );
};
